import NativeEventEmitter from '@framework/data-helpers/event/NativeEventEmitter';
import BulkQuestionUploadAdapter
  from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/BulkQuestionUploadAdapter';
import { IUploadStrategy, UploadProcessing, IFileStream } from '@dealroadshow/file-uploader';
import { IUploadProcessingEventEmitter } from '@dealroadshow/file-uploader/dist/uploadProcessing/IUploadProcessing';

export default class BulkQuestionUploadStrategy implements IUploadStrategy {
  constructor(protected readonly uploadAdapter: BulkQuestionUploadAdapter) {
  }

  async createUpload(
    fileStream: IFileStream,
    fileSize: number,
    fileName: string,
    options: {
      dataroomId: number,
      abortController: AbortController,
    },
  ) {
    const eventEmitter = new NativeEventEmitter();
    const uploadAdapter = this.createAdapter(this.uploadAdapter, eventEmitter);

    uploadAdapter.upload(fileStream, fileSize, {
      fileName,
      ...options,
    });

    return new UploadProcessing(
      '', // We don't have uuid in our uploadAdapter
      fileSize,
      options,
      uploadAdapter,
      // NativeEventEmitter implements .on()/.emit() used by UploadProcessing at runtime.
      // The cast is needed because the library's interface extends Node.js EventEmitter type.
      eventEmitter as unknown as IUploadProcessingEventEmitter,
    );
  }

  // @ts-ignore
  protected createAdapter = <T extends IAdapter>(adapter: T, eventEmitter: NativeEventEmitter): T => {
    const clone = Object.assign(Object.create(Object.getPrototypeOf(adapter)), adapter);
    clone.setEventEmitter(eventEmitter);
    return clone;
  };
}
